/* eslint-disable array-callback-return */
import { fromJS } from 'immutable';

import { ApiUrl2,UserToken } from '../../../helper/HelperAuth'
import { GetChatList } from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'
import { normalize } from '../../../infra/helper/normalizeHelper'

export default (page, search) => async (dispatch, getState) => {
    
    const Authorization = UserToken;
    const url = ApiUrl2 + '/helpdesk-getqueue';
    
    if(page === undefined){
        page = 1;
    }

    const argument = {  
        method: 'POST',
        headers : {
            'Authorization': Authorization,
        },
    };  

    const response = await doFetch(url,argument);
    var data = fromJS({});
    
    if(response.ok){
        data = fromJS(await response.json());
        dispatch({ type: GetChatList, queues: data });
    }
};